import { cn } from '@mint-lib/tw-utils';

import { CommandItem as BasicCommandItem } from '../../lib/command.jsx';
import { itemVariants } from '../../lib/variants.jsx';
export default function CommandItem({
  className,
  ...props
}: React.ComponentProps<typeof BasicCommandItem>) {
  return (
    <BasicCommandItem
      className={cn(
        itemVariants({
          popoverItem: 'default',
        }),
        'group/command-item flex items-center justify-between outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:text-text-disabled data-[selected=true]:bg-ui-hover',
      )}
      {...props}
    />
  );
}
